import React from 'react'
import { displayDealId } from '../../utils/dealConstants'
import AppLink from './AppLink.jsx'

// The one way a deal id is shown (ruling 1, 2026-10-16). It shows the
// reference code or the HubSpot id, never the quote UUID, and it opens the deal:
//   - `onOpen`: the page's own deal modal, where the page has one;
//   - `newTab`: a new tab, for warehouse work screens, so work in progress stays;
//   - otherwise All Deals in the same tab, which opens the modal from `?dealId=`.

const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
const UUID_ONLY_LABEL = 'Open deal'

/**
 * The All Deals address that opens one deal.
 * @param {string|number} dealId the id GET /api/deals/:id accepts
 * @returns {string}
 */
export function dealHref(dealId) {
  return `/deals/all?dealId=${encodeURIComponent(String(dealId))}`
}

/**
 * @param {{
 *   deal?: object,               // a deal detail or grid row (id, quote_id, reference_code)
 *   dealId?: string|number,      // the id to open, for rows of another shape
 *   reference?: string|null,     // the text to show, for rows of another shape
 *   newTab?: boolean,
 *   onOpen?: () => void,
 *   className?: string,
 * }} props
 */
export default function DealLink({ deal, dealId, reference, newTab = false, onOpen, className = '' }) {
  const target = dealId ?? deal?.id
  if (target == null || target === '') return null

  return (
    <AppLink href={dealHref(target)} newTab={newTab} onOpen={onOpen} className={`deal-link ${className}`.trim()}>
      {dealLabel({ deal, target, reference })}
    </AppLink>
  )
}

function dealLabel({ deal, target, reference }) {
  const label = reference || (deal ? displayDealId(deal) : '') || String(target)
  return UUID_PATTERN.test(label) ? UUID_ONLY_LABEL : label
}
